(function($) {
	"use strict"; 

	// self-hoisting
	var Core = {};
	var API = {};
	var deferredPrompt = null;
	const AudioContext = window.AudioContext || window.webkitAudioContext;
	var audioContext = null; // cannot instantiate AudioContext before gesture

	// one instance
	window.__chatableMembers = {};

	/**
	 * Enablement on DOMContentLoaded
	 * @internal
	 */
	jQuery(function(e) {
		Core.module.init();
		Core.plugin.init();
		if ($('[data-toggle="tooltip"]').length) $('[data-toggle="tooltip"]').tooltip() //Enable tooltip
		$('.popover-toggle').popover();
		return false;
	});

	$(".js__full_screen").on('click',function(){
		$(document).fullScreen(true);
	});

  $(".dings-menu-dropdown").on("show.bs.dropdown", function(){
    $(this).find(".btn .caret").addClass('caret-up');
  });
  $(".dings-menu-dropdown").on("hide.bs.dropdown", function(){
    $(this).find(".btn .caret").removeClass('caret-up');
	});

	/**
	 * Fix for scroll on refresh
	 * @internal
	 */
	window.onbeforeunload = function() {
			window.scrollTo(0, 0);
	};

	/**
	 * Public APIs - Dings Endpoints
	 * @internal
	 */
	API.methods = {
		/**
		 * GET a component
		 * @internal
		 */
		getComponent: function(cmp, params, cb){
			// get locale for current rendering
			let locale = $('meta[name=current-language]').attr('content');

			// do ajax request always with locale
			let data = Object.assign({}, {locale}, params);
			$.ajax({
				type: 'GET',
				url: '/api/v1/components/' + cmp,
				data: data,
				dataType: 'json',
				success: function (data) {
					console.log('API: ', data);
					if (cb) cb(data);
					return false;
				},
				error: function () {
					console.error(arguments);
				}
			});
		},

		/**
		 * GET a page
		 * @internal
		 */
		getPage: function(page, params, cb){
			// get locale for current rendering
			let locale = $('meta[name=current-language]').attr('content');

			// do ajax request
			let data = Object.assign({}, {page, locale}, params);
			$.ajax({
				type: 'GET',
				url: '/api/v1/pages/render',
				data: data,
				dataType: 'json',
				success: function (data) {
					console.log('API: ', data);
					if (cb) cb(data);
					return false;
				},
				error: function () {
					console.error(arguments);
				}
			});
		},

		/**
		 * POST favorites
		 * @internal
		 */
		postFavorites: async function(data){
			return new Promise((resolve, reject) => {
				$.ajax({
					type: 'POST',
					url: '/api/v1/favorites',
					data: data,
					dataType: 'json',
					success: function (data) {
						if (data && data.status && 'ok' === data.status) {
							$('#value-favorites-group-name').text(data.group);
							$('#favorites-saved').show();
							setTimeout(function(){ $('#favorites-saved').hide(); }, 5000);
						}
						return resolve(true);
					},
					error: function (data) {
						console.log("[ERROR] ", data);
						$('#favorites-error').show();
						setTimeout(function(){ $('#favorites-error').hide(); }, 10000);
						return reject();
					}
				});
			});
		},

		/**
		 * POST message reception
		 * @internal
		 */
		postReception: async function(data){
			console.log("sending ajax: ", data);
			return new Promise((resolve, reject) => {
				$.ajax({
					type: 'POST',
					url: '/api/v1/message/reception',
					data: data,
					dataType: 'json',
					success: function(result) {
						console.log("marked read: ", result);
						return resolve(true);
					},
					error: function (error) {
						console.log("[ERROR] ", error);
						return reject();
					}
				});
			});
		},

		/**
		 * POST a dings
		 * @internal
		 */
		postDings: function(_button, cb){
			var _form = _button.find('form.checkin-type-form')[0],
					_game = $(_form).attr('data-game');

			if (! _form || ! _form.getAttribute || ! _form.getAttribute('action').length) {
				return false;
			}

			$.ajax({
				type: 'POST',
				url: _form.getAttribute('action'),
				data: $(_form).serialize(),
				success: function(data) {
					console.log("success: ", data);

					// update this checkin type's form action
					$('form.checkin-type-form[data-game=' + _game + ']').each(function(i, elm){
						$(this)[0].setAttribute('action', data.next);
					});

					// update friends form action and CSRF
					$('form.checkin-type-friends-form')[0].setAttribute('action', data.friends);
					$('form.checkin-type-friends-form').attr('data-game', _game);
					$('form.checkin-type-friends-form[data-game=' + _game + ']').find('input[name=_token]').val(data.csrf);

					// - automatically trigger "friends/partners" input if data.partner is set
					if (data.partner) {
						$('form.checkin-type-friends-form[data-game=' + _game + ']')
							.parents('.modal-body')
							.find('a').first()
							.trigger('click');
						$('form.checkin-type-friends-form[data-game=' + _game + ']')
							.parents('.modal-body')
							.find('input.__js_auto_complete_suggest_wrapper')
							.trigger('focus');
					}

					if (cb) return cb(data);
				},
				error: function (data) {
					console.log("[ERROR] ", data);
				}
			});
		},

		/**
		 * POST a relationship
		 * @internal
		 */
		asyncPostForm: function(_form, cb, err_cb){
			$.ajax({
				type: 'POST',
				url: _form.getAttribute('action'),
				data: $(_form).serialize(),
				success: function(data) {
					console.log("success: ", data);
					if (cb) return cb(data);
				},
				error: function (data) {
					console.log("[ERROR] ", data);
					if (err_cb) return err_cb(data);
				}
			});
		},

		/**
		 * POST live chat presence updates
		 * @internal
		 */
		postPresence: async function(data){
			return new Promise((resolve, reject) => {
				$.ajax({
					type: 'POST',
					url: '/api/v1/chat/presence',
					data: data,
					dataType: 'json',
					success: function(result) {
						return resolve(true);
					},
					error: function (error) {
						console.log("[ERROR] ", error);
						return reject();
					}
				});
			});
		}

	};

	/**
	 * Private API - Helpers
	 * @internal
	 */
	Core.helpers = {

		split: function(val){
			return val.split(/,\s*/);
		},

		extractLast: function(term){
			return Core.helpers.split(term).pop();
		},

		asyncRenderComponent: async function(ui, _sel, l, i, _field_name){
			var _bare = $('#' + _field_name + '_bare_selection'),
					_copy = _bare && _bare.length ? _bare.clone() : $('<div></div>'),
					_results_field = $('#' + _field_name + '_results');

			if ('component' in ui.item) {
				// server-side component rendering
				let params = 'component_params' in ui.item && ui.item['component_params'].length
					? JSON.parse(ui.item['component_params'])
					: {};
				await API.methods.getComponent(ui.item['component'], Object.assign({}, {slug: _sel[i]}, params), function(cmp) {
					_copy.html(cmp.html);
				});
			}
			// no-component
			else {
				_copy.text(_sel[l]);
				_copy.addClass('ac-selected-value');
				_copy.attr('id', '');

				// add icon if available
				if ('icon' in ui.item) {
					var lib = ui.item['icon'].startsWith('fa') ? 'fa' : 'mdi';
					_copy.html('<i class="' + lib + ' ' + ui.item['icon'] + '"></i>&nbsp;'+ _sel[l]);
				}
			}

			// add selection and clear input
			_copy.prependTo(_results_field);
			_copy.show();
		},

		extendAutocomplete: function(){
			$.widget("ui.autocomplete", $.ui.autocomplete, {
				_renderMenu: function(ul, items) {
					var that = this;
					ul.attr("class", "nav nav-pills nav-stacked  bs-autocomplete-menu");
					$.each(items, function(index, item) {
						that._renderItemData(ul, item);
					});
				},
				_resizeMenu: function() {
					var ul = this.menu.element;
					ul.outerWidth(Math.min(
						// Firefox wraps long text (possibly a rounding bug)
						// so we add 1px to avoid the wrapping (#7513)
						ul.width("").outerWidth() + 1,
						this.element.outerWidth()
					));
				}
			});
		},

		autocompletePayload: function(_this,onSelect){
			var _data = _this.data(),
					_field_name = _this.attr('name'),
					_hidden_field = $('#' + _data.hidden_field_id),
					_results_field = $('#' + _field_name + '_results'),
					_api_endpoint = _data.api_endpoint,
					_sel_cb = onSelect ? onSelect : null,
					feedback_icon = _this.next('.bs-autocomplete-feedback').hide();

			return {
				minLength: 2,
				autoFocus: true,
				source: async function(request, response) {
					var data = $.getJSON( _api_endpoint, {
						term: Core.helpers.extractLast(request.term)
					}, response);
				},
				search: function() { feedback_icon.show(); },
				response: function() { feedback_icon.hide(); },
				focus: function(event, ui) { event.preventDefault(); },
				select: async function(event, ui) {
					var sel = ui.item, l = _data.item_label, i = _data.item_id;
					if (_results_field && _results_field.length) {
						// - add to results field if available
						await Core.helpers.asyncRenderComponent(ui, sel, l, i, _field_name);
						_this.val('');
					}
					else {
						// - or add results to autocomplete field
						var terms = Core.helpers.split(_this.val());
						terms.pop();
						terms.push(ui.item[_data.item_label]);
						terms.push("");
						_this.val(terms.join(', '));
					}
					// update input and values
					_hidden_field.val(_hidden_field.val() + ', ' + sel[i]);
					_hidden_field.val(_hidden_field.val().replace(/^(\[\])?(\s?,\s?)(.+)/, '$3'));
					event.preventDefault();
					if (_sel_cb) return _sel_cb(_hidden_field.val());
				}
			};
		}, // end autocompletePayload()

		/**
		 * @internal This method *must* be bound to click listener.
		 */
		playSound: function() {
			let audioElement = document.getElementById("dings-sound");

			// start context if not yet
			if (null === audioContext) {
				audioContext = new AudioContext();
			}

			// check if context is in suspended state (autoplay policy)
			if (audioContext.state === 'suspended') {
				audioContext.resume();
			}

			// play track
			audioElement.play();
		},

		showAgeRestrictionOverlay: function() {
			let $modal = $('#modal-age-restriction-game-overlay');
			if (! $modal.length) return ;
			$modal.modal('show');

			// BLOCK closing popup
			$modal.on('hidden.bs.modal', function() {
				$modal.modal('show');
			});
		},

		animateCSS: function(element, animation, prefix = 'animate__', styleProps = {}){
			return new Promise((resolve, reject) => {
				const animationName = `${prefix}${animation}`;

				var node = null;
				if (typeof element === 'string') 
					node = document.querySelector(element);
				else
					node = element;

				node.classList.add(`${prefix}animated`, animationName);

				if (styleProps && Object.keys(styleProps).length) {
					for (let prop in styleProps) {
						node.style.setProperty(prop, styleProps[prop]);
					}
				}

				// When the animation ends, we clean the classes and resolve the Promise
				function handleAnimationEnd(event) {
					event.stopPropagation();
					node.classList.remove(`${prefix}animated`, animationName);
					resolve('Animation ended');
				}

				node.addEventListener('animationend', handleAnimationEnd, {once: true});
			});
		},

		initAsyncForms: function(_this){
			let $form = _this.find('form'),
					$submits = _this.find('.__js_dings_submit');

			// make no noise if there is no form on page
			if (! $form.length) return ;

			// first disable ("multi-click fix")
			$form.off('submit');
			$form.on('submit', function(){
				$(".__js_dings_submit", this).attr('disabled', 'disabled');
				return true;
			});

			// then register listener for form submit
			$submits.on('click', function(e) {
				var $form = $($(this).attr('data-form')),						
						_params = JSON.parse($(this).attr('data-params')),
						_callback = $(this).attr('data-callback'),
						_buttons = $form.find('.__js_async_form_buttons'),
						// hide feedback on submit
						_loading = $form.find('.__js_async_form_set_loading').first(),
						_success = $form.find('.__js_async_form_feedback').hide();

				// update server-side field values pre-submit
				for (let field in _params) {
					$form.find('input[name=' + field + ']').val(_params[field]);
				}

				// set loading
				if (_loading) _loading.addClass('is-loading');

				// wrap submit in ajax request
				API.methods.asyncPostForm($form[0], function(results){
					console.log("done: ", results);

					if (_buttons.length && _success.length) { 
						_buttons.hide();
						_success.show();
					}

					if (_callback && _callback.length && _callback in window && undefined !== window[_callback]) {
						window[_callback].apply(this, [results]);
					}

					// unset loading
					if (_loading) _loading.removeClass('is-loading');
					$(".__js_dings_submit", this).removeAttr('disabled');
				}, function(err) {
					// try to find an error feedback field
					let _err_feedback = $form.find('.__js_async_form_error[data-status=' + err.status + ']').first();

					if (_success.length) _success.hide();
					if (_err_feedback.length) _err_feedback.show();

					// unset loading
					if (_loading) _loading.removeClass('is-loading');
				});

				return true; // continuePropagation
			});
		},

		initDialogs: function(){
			let $dialogs = $('.__js_dings_dialog');
			$dialogs.each(function(i, elm){
				let $dialog = $(elm),
						page = $dialog.attr('data-page'),
						_head = $dialog.find('.modal-title').first(),
						_body = $dialog.find('.modal-body').first();

				// async page load
				$(this).off('show.bs.modal');
				$(this).on('show.bs.modal', function(e){
					var _btn = $(e.relatedTarget);

					API.methods.getPage(page, {params: {sid: _btn.attr('data-sid')}}, function(cmp) {
						_head.html(cmp.header);
						_body.html(cmp.html);

						Core.helpers.initAsyncForms(_body);
					});
				});

				// page reset
				$(this).on('hidden.bs.modal', function(e){
					_head.html('&nbsp;');
					_body.html('&nbsp;');
				});
			});
		},

		initPaginator: function(_feed, _loading, _paginator, page){
			_paginator.off('click');
			_paginator.on('click', function(e){
				var offset = parseInt($(this).attr('data-page'));
				offset = isNaN(offset) ? 1 : offset;

				// - enable loading animation
				_loading.show();
				Core.helpers.animateCSS(_loading[0], 'backInUp');

				/*no-await*/ API.methods.getPage(page, {params: {offset}}, function(cmp) {
					// - update DOM
					_feed.html(_feed.html() + cmp.html);

					// - disable loading animation
					_paginator.attr('data-page', offset+1);
					_loading.hide();

					// - initialize dynamic elements
					Core.helpers.initStreamable(_feed, _loading, _paginator, page, false); // resetPaginator = false
				});
				return false;
			});
		},

		initStreamable: function(_feed, _loading, _paginator, page, resetPaginator = true){
			// - initialize reactions elements (if any)
			Core.module.reactions();

			// - initialize streamable dialogs (if any)
			Core.helpers.initDialogs();

			// - animate first entry to catch attention
			var _first = _feed.find('.stream-entry').first();
			if (!!_first) {
				Core.helpers.animateCSS(_first[0], 'tada', 'animate__', {'--animate-duration': '1s'});
			}

			// - "load more"
			if (resetPaginator === true) {
				Core.helpers.initPaginator(_feed, _loading, _paginator, 'components.pages.feed');
			}
		},
	
		addLiveChatMessage: function(_parent, broadcast){
			var _lchat = _parent.find('.__js_dings_chat');

			// - bail out with missing obligatory data
			if (!_lchat || !broadcast || !broadcast.entry_type || !broadcast.entry_type.length) return;

			// - explicitely hoist params in following
			// block to avoid pushing empty values
			{
				var params = {};

				// - in case we have a chat entry (achievement, chat, checkin, bot)
				if ('entry_id' in broadcast && undefined !== broadcast['entry_id']) {
					params = {
						entryable: broadcast.entry_id,
						etype: broadcast.entry_type
					};
				}
				// - in case we have a reaction entry (clap x times, etc.)
				else {
					params = {
						sender: broadcast.player,
						countable: broadcast.entry_count,
						rtype: broadcast.entry_type,
					};
				}

				// - render in live chat
				API.methods.getComponent('dings-livechat-entry', params, function(cmp) {
					$(cmp.html).appendTo(_lchat);

					// XXX "unread messages" in case of scroll
					_lchat[0].scrollTop = _lchat[0].scrollHeight;
				});
			}
		},

		updateCountdown: function($wrap){
			var strpadTen = function(num, pad) {
				return num < 10 ? `${pad}${num}` : ('' + num);
			};

			let $days = $wrap.find('[data-type=d]').first(),
					$hour = $wrap.find('[data-type=h]').first(),
					$mins = $wrap.find('[data-type=m]').first(),
					current = 0;

			// - read + update counter
			current = parseInt($mins.text());
			if (isNaN(current)) current = 0;
			current = current - 1;

			// - simple update
			if (current > 0) {
				$mins.text('' + strpadTen(current, '0'));
				return true;
			}

			// - need to also update HOURS
			let h = parseInt($hour.text()),
					d = parseInt($days.text()),
					h1 = h === 1;

			h = isNaN(h) ? 0 : h - 1;
			if (h > 0) {
				$hour.text('' + strpadTen(h, '0'));
				return true;
			}
			else h = 0;

			// - need to also update DAYS
			d = isNaN(d) ? 0 : d - 1;

			if (d < 0) d = 0;
			$days.text('' + d);

			if (h1 === true) {
				current = 59;
				$mins.text('' + current);
				return true;
			}
			else if(d === 0 && h === 0) {
				$mins.text('00');
				return false;
			}
		}

	};

	/**
	 * App modules - Initialize dynamic components
	 * and pages. 
	 *
	 * @note Further refactoring should extract components
	 * 			 in the Core.components class below.
	 */
	Core.module = {
		init : function(){
			// first things first
			if ($('#dings-wrapper').length) Core.module.dings();

			Core.module.css($(".js__width"),"width");
			Core.module.dropDown("js__drop_down",false);
			Core.module.logout();
			Core.module.toggle();

			// initialize AJAX
			$.ajaxSetup({
				headers: {
					'X-CSRF-TOKEN': jQuery('meta[name="csrf-token"]').attr('content')
				}
			});

			// extends autocomplete to add `nav-*` classes
			Core.helpers.extendAutocomplete();

			// Core modules initialization
			Core.module.autocomplete();
			Core.module.a2hs();
			Core.module.notifications();
			Core.module.geolocation();
			Core.module.achievements();
			Core.module.delegation();
			Core.module.store();
			Core.module.prevailingModalBoxes();
			Core.module.dataRequests();
			Core.module.messaging();
			Core.module.reactions();
			Core.module.streamable();

			// init components
			Core.components.DingsSelector();
			Core.components.DingsAction();
			Core.components.Countdown();

			return false;
		},
		css : function(selector,name,data){
			if (!data){
				data = name;
			}
			selector.each(function(){
				var raw = $(this).data(data);
				if (raw){
					var dict = {};
					dict[name] = raw
					$(this).css(dict);
				}
			});
			return false;
		},
		dropDown : function(selectorTxt,isMobile){
			var selector = $("." + selectorTxt);
			selector.each(function(){
				var current_selector = $(this);
				current_selector.on("click",".js__drop_down_button",function(event){
					event.preventDefault();
					if ($(window).width() < 1025 || isMobile === false){
						if (current_selector.hasClass("active")){
							current_selector.removeClass("active");
						}else{
							selector.removeClass("active");
							current_selector.addClass("active");
						}
					}
					return false;
				});
			});
			$("html").on("click",function(event){
				var selector = $(event.target);
				if (!(selector.hasClass(selectorTxt) || selector.parents("." + selectorTxt).length)){
					$("." + selectorTxt + ".active").removeClass("active");
				}
			});
			return false;
		},
		logout: function(){
			var title = $("#text-logout-title").text(),
			    desc = $("#text-logout-description").text(),
			    conf = $("#text-logout-confirmation").text(),
			    denial = $("#text-logout-denial").text();

			$(".js__logout").on("click",function(event){
				event.preventDefault();
				swal({
					title: title,
					text: desc,
					type: "warning",
					showCancelButton: true,
					confirmButtonColor: "#DD6B55",
					confirmButtonText: conf,
					cancelButtonText: denial,
					closeOnConfirm: false,
					closeOnCancel: true,
					confirmButtonColor: '#f60e0e',
				}, function(isConfirm){
					if (isConfirm) {
						document.getElementById('logout-form').submit();
						return false;
					} else {
					} 
				});
				return false;
			});
		},
		toggle: function(){
			$(".js__toggle_open").on("click",function(event){
				event.preventDefault();
				$($(this).data("target")).toggleClass("active");
				return false;
			});
			$(".js__toggle_close").on("click",function(event){
				event.preventDefault();
				$(this).parents(".js__toggle").removeClass("active");
				return false;
			});
			$("body").on("click",function(event){
				if ($(".js__toggle").hasClass("active")){
					var selector = $(event.target);
					if (!(selector.hasClass("js__toggle_open") || selector.hasClass("js__toggle") || selector.parents(".js__toggle_open").length || selector.parents(".js__toggle").length)){
						$(".js__toggle").removeClass("active")
					}
				}
			});
			return false;
		},
		autocomplete: function(){
			if (! $('.bs-autocomplete').length) return;

			$('.bs-autocomplete').each(function() {
				var _this = $(this),
						_data = _this.data();

				_this.after('<div class="bs-autocomplete-feedback form-control-feedback"><div class="loader">Loading...</div></div>')
					.parent('.form-group').addClass('has-feedback');

				_this.autocomplete(Core.helpers.autocompletePayload(
					_this
				)).data('ui-autocomplete')._renderItem = function(ul, item) {
					return $('<li></li>')
						.data("item.autocomplete", item)
						.append('<a>' + item[_data.item_label] + '</a>')
						.appendTo(ul);
				};
			}); // end autocomplete
		},

		/**
		 * Enable internal Reactions API
		 * @return void
		 */
		reactions: function(){

			var lastClap = null;

			/**
			 * Toggle the .i-reacted class state
			 * @internal
			 */
			var toggleReacted = function(reaction_elm){
				// remove .i-reacted from once-only siblings
				if (reaction_elm.data('times') === 1) {
					reaction_elm
						.siblings('a.__js_reaction[data-times=1].i-reacted')
						.toggleClass('i-reacted');
				}
				else if (!reaction_elm.hasClass('i-reacted'))
					// set .i-reacted flag
					reaction_elm.toggleClass('i-reacted');
			};

			/**
			 * POST a new reaction
			 * @internal
			 */
			var postReaction = function(data, reaction_elm, doUpdateCounters = true){
				$.ajax({
					type: 'POST',
					url: '/api/v1/reaction',
					data: data,
					dataType: 'json',
					success: function (data) {
						if (doUpdateCounters) {
							// update all counters
							updateCounters(data, reaction_elm);
						}

						// auto-hide tooltip
						setTimeout(function() {
							reaction_elm.tooltip('hide');
						}, 1000);
						return false;
					},
					error: function (data) {
						console.error(data);
					}
				});
			};

			/**
			 * Update claps
			 * @internal
			 */
			var updateClaps = function(reaction_elm){
				// read DOM
				let $wrapper = reaction_elm.parents('.claps-wrapper').first();
				let $reacting = $wrapper.find('a.__js_reaction[data-type=clap]');
				let reactionableId = $reacting.attr('data-rid');
				let reactionableType = $reacting.attr('data-rtype');

				// whether current clap must be reported to server
				let doPost = lastClap === null || !lastClap[reactionableId];
				if (lastClap === null) lastClap = {};

				// read claps
				let total = parseInt($reacting.find('.counter').text());
				if (isNaN(total) || total <= 0) total = 0;
				let previous = parseInt($wrapper.find('a.__js_reaction[data-type=clap] .counting').text());

				// increase claps count
				lastClap[reactionableId] = ++previous;
				let $clap = $wrapper.find('a.__js_reaction[data-type=clap]');

				// update DOM
				$clap.find('.counting').text(''+ lastClap[reactionableId]);
				$clap.find('.counter').text(''+ (++total));

				if (doPost) {
					// visual feedback animation
					Core.helpers.animateCSS(reaction_elm[0], 'flip', 'animate__', {'--animate-duration': '1s'});
					// end visual feedback animation

					if (total === 1) {
						// toggle .i-reacted
						toggleReacted(reaction_elm);
					}

					setTimeout(function() {
						// if still clapping after 3 seconds, do not issue request, wait until done
						let $counting = $('a.__js_reaction[data-rid=' + reactionableId + '][data-type=clap] .counting');
						let counting = parseInt($counting.text());

						$counting.text('0');
						lastClap[reactionableId] = null;
						postReaction({
							type: 'clap',
							rid: reactionableId,
							rtype: reactionableType,
							added: counting,
						}, reaction_elm, false); // false => "do not update counters"
					}, 3000);
				}
			};

			/**
			 * Update reactions counters
			 * @internal
			 */
			var updateCounters = function(data, reaction_elm){
				// reset all first
				let $wrapper = reaction_elm.parents('.interactions-reactions-wrapper').first();
				$wrapper.find('a.__js_reaction .counter').text(' ');

				// then update to new counters
				let types = Object.keys(data.counters);
				for (let i in types) {
					let type = types[i];
					$wrapper
						.find('a.__js_reaction[data-type="' + type + '"] .counter')
						.text('' + data.counters[type]);
				}
			};

			$('.reaction[title]').tooltip({placement: 'top'});

			/* Reactions Click Events */
			$('.__js_reaction').on('click',function(event){
				event.preventDefault();
				var reaction_elm = $(this);
				var type = reaction_elm.data('type');
				var rid = reaction_elm.data('rid');
				var rtype = reaction_elm.data('rtype');
				var data = {
					type: type,
					rid: rid,
					rtype: rtype,
				};

				// Clap is "react many times"
				if (type === 'clap') updateClaps(reaction_elm);
				// Other types post reaction instantly
				else postReaction(data, reaction_elm);

				return false;
			});
			/* End Reactions Click Events */
		},

		/**
		 * Enable / Ask for Notification API permissions
		 * @link https://developer.mozilla.org/en-US/docs/Web/API/notification
		 * @return void
		 */
		notifications: function(){
			if (!("Notification" in window)) {
				console.error('Your browser does not support the Notification API.');
				return ;
			}
			// if granted, no init needed
			else if (Notification.permission === 'granted') {
				return ;
			}
			// otherwise, ask for permission
			else if (Notification.permission !== 'denied') {
				Notification.requestPermission();
			}
			// denied, respect the end-user.
		},

		/**
		 * Enable / Ask for Geolocation API permissions
		 * @link https://developer.mozilla.org/en-US/docs/Web/API/Geolocation
		 * @return void
		 */
		geolocation: function(){
			/**
			 * POST a new geolocation
			 * @internal
			 */
			var postPosition = function(data){
				$.ajax({
					type: 'POST',
					url: '/api/v1/location',
					data: data,
					dataType: 'json',
					success: function (data) {
						return false;
					},
					error: function (data) {
						console.error(data);
					}
				});
			};

			/**
			 * Read current position using Geolocation API
			 * @internal
			 */
			var getPosition = function(){
				navigator.geolocation.getCurrentPosition((position) => {
					// minify coordinates
					let data = Object.assign({}, position.coords, {
						latitude: position.coords.latitude.toFixed(8),
						longitude: position.coords.longitude.toFixed(8)
					});

					// enable geolocation restricted fields
					$(".geolocation-only").collapse('show');
					$('input[name=latitude]').val(data.latitude);
					$('input[name=longitude]').val(data.longitude);

					// store coordinates
					postPosition(data);
				});
			};

			if (!("geolocation" in navigator)) {
				console.error('Your browser does not support the Geolocation API.');
				return ;
			}
			else {
				// if we have Permission API, use it
				if ('permissions' in navigator) {
					navigator.permissions.query({name: 'geolocation'}).then((status) => {
						console.log("GEO API response: ", status);
						if (status.state === 'granted') {
							// geolocation request only if granted.
							getPosition();
						}
						else if (status.state === 'prompt') {
							// geolocate to prompt user
							getPosition();
						}
						else {
							// denied / ignored, respect the end-user
							return;
						}
					});
				}
				// Permission API not available
				else {
					// geolocation request to trigger Permission.
					getPosition();
				}
			}
		},

		/**
		 * Enable "Add to Home Screen" API
		 * @link https://developer.mozilla.org/en-US/docs/Web/Progressive_web_apps/Add_to_home_screen
		 * @return void
		 */
		a2hs: function(){
			// Detects if device is on iOS 
			var that = this;
			const isIos = () => {
				const userAgent = window.navigator.userAgent.toLowerCase();
				return /iphone|ipad|ipod/.test( userAgent ) && 'setState' in that;
			};

			// Detects if device is in standalone mode
			const isiOSInStandaloneMode = () => ('standalone' in window.navigator) && (window.navigator.standalone);

			// Checks if should display install popup notification:
			if (isIos() && !isiOSInStandaloneMode()) {
				this.setState({ showInstallMessage: true });
				return ;
			}

			// Chrome >= 68 requires serviceWorker for offline usage
			// ServiceWorker is also a requirement for A2HS on Chrome.
			if ('serviceWorker' in navigator) {
				navigator.serviceWorker.register('/offline.min.js', {
					scope: '/',
					enabled: true,
					registrationStrategy: 'registerImmediately'
				});
			}

			// On devices where it's possible, the `beforeinstallprompt` event will
			// be fired on every page load. To respect the end-user, we won't prompt
			// for installation unless the end-user requests it (button click)
			window.addEventListener('beforeinstallprompt', (e) => {
				// Prevent Chrome 67 and earlier from automatically showing the prompt
				e.preventDefault();

				// Stash the event so it can be triggered later.
				deferredPrompt = e;
			});

			window.addEventListener('appinstalled', (evt) => {
				$('#a2hs-message').remove();
			});

			if (navigator.standalone || window.matchMedia('(display-mode: standalone)').matches) {
				// app already launched as standalone
				return ;
			}

			// Tell user they can A2HS
			if ($('#a2hs-message').length) $('#a2hs-message').collapse('show');

			// register event for when end-user requests a2hs
			$('#a2hs-button').on('click', function(e) {
				$('#a2hs-message').collapse('hide');

				if (!('prompt' in deferredPrompt)) {
					return false;
				}

				// show the "Install App" prompt (A2HS API)
				deferredPrompt.prompt();
				deferredPrompt.userChoice.then((choiceResult) => {
					// Display thank you message and remove
					if (choiceResult.outcome === 'accepted') {
						$('#a2hs-message-success').collapse('show');
						setTimeout(function() {
							$('#a2hs-message-success').collapse('hide');
						}, 10000);
						deferredPrompt = null;

						// save history in GA when available
						gtag('event', 'install', {
							'event_category': 'acquisition',
							'event_label': 'accepted',
							'value': 1
						});
					}
					// Install denied, set back message
					else {
						$('#a2hs-message').collapse('show');
					}
				});
			});

			$('.__js_dismiss').on('click', function(e){
				let target = $(this).data('target');
				if (! $(target).length) return false;
				$(target).collapse('hide');
				return false;
			});
		},

		/**
		 * Implementation for Dings action on frontend
		 *
		 * @return void
		 */
		dings: function(){
			// - make sure dings only works with sound
			if (! $('#dings-sound').length) return;

			// - then check if Dings action available
			var can = parseInt($('#dings-wrapper').attr('data-canplay'));
			var min = parseInt($('#dings-wrapper').attr('data-minage'));
			if (isNaN(can) || can <= 0) {
				if (!isNaN(min) && min > 0) Core.helpers.showAgeRestrictionOverlay();
				return ; // break here (no event listener for buttons!)
			}

			// - then map listeners

			$('.checkin-type-form').off('submit');
			$('.checkin-type-form').on('submit', function(){
				$(".__js_dings_trigger", this).attr('disabled', 'disabled');
				return true;
			});

			$('.__js_dings_trigger').off('click');
			$('.__js_dings_trigger').on('click', function(e){
				e.preventDefault();
				e.stopPropagation();

				var _this = $(this),
						form = _this.find('form.checkin-type-form')[0],
						with_sound = _this.attr('data-sound') === '1',
						_checkbox = _this.find('.with-checkbox .__js_dings_checkbox').first(),
						has_restriction = _this.attr('data-restriction') === '1',
						has_popin = false === has_restriction && _this.attr('data-popin') === '1',
						has_animate = false === has_restriction && _this.attr('data-animate') === '1';

				// Dings bound to event listener
				if (with_sound === true) {
					(Core.helpers.playSound.bind(this))();
				}

				// do not miss gtag event
				//XXX should be replaced by PHP event generation
				if (typeof gtag !== 'undefined') {
					gtag('event', 'dings', {
						'event_category': 'actions',
						'value': $(form).attr('data-tid')
					});
				}

				// - partner/friends modal box only showed if no restriction applies
				if (true === has_popin) {
					var $modal = $('#modal-dings-thank-you');
					$modal.modal('show');

					// focus "friends/partners" input field when displayed
					$('.__js_auto_complete_suggest_wrapper').on('shown.bs.collapse', function(e){
						$('#delegate-invite-friends-input').trigger('focus');
					});

					// map "friends/partners" form submission
					$('#close-dings-thank-you').off('click');
					$('#close-dings-thank-you').on('click', function(e){
						var friends = $('input[name=friends]').val();

						if (friends && friends.length) {
							var $form = $(this).parents('.modal-content').find('form.checkin-type-friends-form');

							API.methods.asyncPostForm($form[0], function(result){
								console.log("done: ", result);
							});

							$form.find('input[name!="_token"]').val('');
							return true;
						}

						// resumePropagation
						return true;
					});

					// if "with checkbox", toggle checkbox after button press
					if (_checkbox && _checkbox.length) _checkbox.removeClass('unchecked').addClass('checked');
				}
				// if "with restriction", button should disappear
				else if (true === has_restriction) {
					Core.helpers.animateCSS(_this[0], 'hinge');
					setTimeout(function() { _this.hide(); }, 2000);
				}
				// if "with animation", button bump
				else if (true === has_animate) {
					Core.helpers.animateCSS(_this[0], 'tada');
				}

				// wrap submit in ajax request
				API.methods.postDings(_this, function(results){
					console.log("done: ", results);
				});

				return false;
			}); // end .__js_dings_trigger.click
		},

		/**
		 * Enable internal Achievements API
		 * @return void
		 */
		achievements: function(){
 			if (!$('#achievement-showcase').length) return ;

			/**
			 * GET an achievement
			 * @internal
			 */
			var getAchievement = function(term, cb){
				// get locale for current rendering
				let locale = $('meta[name=current-language]').attr('content');

				// do ajax request
				$.ajax({
					type: 'GET',
					url: '/api/v1/achievement',
					data: {term, locale},
					dataType: 'json',
					success: function (data) {
						console.log('API: ', data);
						updateShowcase(data);
						if (cb) cb();
						return false;
					},
					error: function () {
						console.error(arguments);
					}
				});
			};

			/**
			 * Set loading state
			 * @internal
			 */
			var setLoading = function(){
				$('#achievement-loader').show();
			};

			/**
			 * Unset loading state
			 * @internal
			 */
			var unsetLoading = function() {
				setTimeout(function(){
					$('#achievement-loader').hide();
				}, 1000);
			};

			/**
			 * Add event listeners
			 * @internal
			 */
			var addListeners = function(){
				$('.arrow').on('click', function(e) {
					setLoading();
					let slug = $(this).data('achievement');
					if (slug.length) getAchievement(slug, unsetLoading);
					return false;
				});
			};

			/**
			 * Update achievement showcase
			 * @internal
			 */
			var updateShowcase = function(data){
				// read DOM and update
				let $showcase = $('#achievement-showcase');
				let $container = $showcase.parent('.showcase-container');

				// component re-rendered from API
				$container.html(data.html);
				addListeners();
			};

			$('.achievement-tile').on('click', function(e) {
				setLoading();
				let slug = $(this).attr('data-achievement');
				getAchievement(slug, unsetLoading);
				return false;
			});

			addListeners();
		},

		/**
		 * Enable Dings delegation features
		 * @return void
		 */
		delegation: function(){
			// in case we have "delegated checkin" notifications
			// we shall popin about it, until none remain (or all skipped).
			if (! $('#modal-delegated-checkin-notification').length) return ;

			let $notify = $('#modal-delegated-checkin-notification');

			// data requests PREVAIL
			if (!$('#modal-data-input-request').length && !$('#modal-happy-birthday').length && !$('#modal-guest-login').length) {
				$notify.modal('show');
			}

			$('.delegation-decision-trigger').on('click', function(e){
				var type = $(this).attr('data-type');

				// update value depending on clicked button
				if (type !== 'deny' && type != 'accept') type = 'deny';
				$('input[name=type]').val(type);

				// submit form
				var form = $(this).parents('#modal-delegated-checkin-notification').find('form.checkin-type-delegation-form')[0];
				form.submit();
				return false;
			});
		},

		/**
		 * Enable games store features
		 * @return void
		 */
		store: function(){
			if (! $('.__js_game_install').length) return ;

			/**
			 * POST a game installation
			 * @internal
			 */
			var postInstall = function(data, cb){
				$.ajax({
					type: 'POST',
					url: '/api/v1/games/install',
					data: data,
					dataType: 'json',
					success: function (res) {
						return typeof cb === 'function' ? cb(res) : false;
					},
					error: function (data) {
						console.error(data);
					}
				});
			};

			$('.__js_game_install').on('click', function(e){
				var $button = $(this);
				var action = $button.attr('data-action');
				var gid = $button.attr('data-gid');

				if (action === 'install') {
					postInstall({gid}, function(res){
						$button.text(res.buttonText);
						$button.removeClass('btn-primary').removeClass('btn-success');
						$button.addClass('btn-' + res.buttonClass);
						$button.attr('data-action', res.buttonAction);
					});
				}
				else {
					window.location.href = action;
				}

				return false;
			});
		},

		/**
		 * Enable data input requests
		 * @return void
		 */
		dataRequests: function(){
			if (! $('#modal-data-input-request').length) return ;

			let $notify = $('#modal-data-input-request');
			$notify.modal('show');

			$('.data-input-submit').on('click', function(e){
				var type = $(this).attr('data-type');

				// update value depending on clicked button
				if (type !== 'deny' && type !== 'accept') type = 'accept';
				$('input[name="data-input-type"]').val(type);

				// submit form
				var form = $(this).parents('#modal-data-input-request').find('form.data-input-request-form')[0];
				form.submit();
				return false;
			});
		},

		/**
		 * Enable birthday modal box
		 * @return void
		 */
		prevailingModalBoxes: function(){
			if ($('#modal-happy-birthday').length) {
				let $birthday = $('#modal-happy-birthday');
				$birthday.modal('show');
			}

			if ($('#modal-guest-login').length) {
				let $guestLogin = $('#modal-guest-login');
				$guestLogin.modal('show');
			}
		},

		/**
		 * Enable Dings messaging features
		 * @return void
		 */
		messaging: function(){
			// make no noise if there is no unread messages.
			if (! $('#modal-message-notification').length) return ;

			// read DOM once
			let $notify = $('#modal-message-notification');

			// - first configure event listener(s)
			$('.__js_trigger_allread').on('click', function(e){
				let ids = $('#modal-message-notification ul.nav li.nav-item').map(
					(i, elm) => { return parseInt($(elm).attr('data-id')); }
				).toArray();

				/* no-await */
				API.methods.postReception({ids});
				return true;
			});

			// - then display. Note: data requests PREVAIL
			if (!$('#modal-data-input-request').length
			&& !$('#modal-delegated-checkin-notification').length) {
				$notify.modal('show');
			}
		},

		/**
		 * Enable stream dynamics
		 * @return void
		 */
		streamable: function(){
			// make no noise if there is no stream
			var $stream = $('.__js_dings_stream');
			if (! $stream.length) return ;

			// this block is to explicitely hoist var `_feed`
			// and avoid using empty `$stream` when not set.
			{
				// - asynchronous feeding
				var _feed = $stream.find('.__js_dings_feed').first(),
						_loading = $stream.find('.__js_dings_feed_loading').first(), 
						_paginator = $stream.find('.__js_dings_paginator').first();

				/*no-await*/ API.methods.getPage('components.pages.feed', {}, function(cmp) {
					// - update DOM
					_feed.html(cmp.html);

					// - initialize dynamic elements
					Core.helpers.initStreamable(_feed, _loading, _paginator, 'components.pages.feed');
				});
			}
		}
	};

	/**
	 * App components - component specific JS
	 *
	 * @internal
	 */
	Core.components = {
		DingsSelector: function(){
			if (!$('.__dings_autocomplete').length) return ;

			$('.__dings_autocomplete').each(function() {
				var _this = $(this),
						_data = _this.data(),
						_target = _data.target,
						_info = $('.__dings_autocomplete_info[rel=\'' + _target + '\']'),
						_onSelect = _this.attr('on-select');

				_this.after('<div class="bs-autocomplete-feedback form-control-feedback"><div class="loader">Loading...</div></div>')
					.parent('.form-group').addClass('has-feedback');

				_this.autocomplete(Core.helpers.autocompletePayload(_this, function(result) {
					if (_info.length) {
						var hide = _info.attr('data-autohide');
						_info.show();
						if (undefined === hide || "1" === hide) {
							setTimeout(function() { _info.hide(); }, 5000);
						}
					}

					// execute custom "on-select" handler
					if (_onSelect && _onSelect.length && _onSelect in window && undefined !== window[_onSelect]) {
						window[_onSelect].apply(this, [result]);
					}
				})).data('ui-autocomplete')._renderItem = function(ul, item) {
					return $('<li></li>')
						.data("item.autocomplete", item)
						.append('<a>' + item[_data.item_label] + '</a>')
						.appendTo(ul);
				};
			}); // end .__dings_autocomplete.autocomplete()
		}, // end DingsSelector

		DingsAction: function(){
			if (! $('.__js_dings_action').length) return ;

			$('.__js_dings_action').on('click', function(e){
				var _this = $(this),
						_data = _this.data(),
						_action = _data.action,
						$row = _this.parents('.__js_dings_trigger'),
						$menu = $row.find('.checkin-type-menu').hide();

				if (_action === 'menu') {
					$menu.show();
				}
				else if (_action === 'delete' && confirm('Are you sure?')) {
					$row.remove();

					// - remove from value of __dings_autocomplete
					if ($('.__dings_autocomplete').length) {
						var _ac = $('.__dings_autocomplete'),
								_onDelete = _ac.attr('on-delete'),
								_target = _ac.attr('data-target'),
								_input  = _ac.siblings('input[name="' + _target + '"]').first(),
								_type   = $row.attr('data-type'),
								_rsafe  = _type.replace(/([\-\.\$\^])/g, '\\$1'),
								_regex  = new RegExp(
									// starts with word + comma(?)
									'^(' + _rsafe + '([,\\s])*)|' +
									// starts with comma(?) + word
									'(([,\\s])+' + _rsafe + ')', 'g');

						let new_value = _input.val().replace(_regex.valueOf(), '');
						_input.val(new_value);

						// execute custom "on-delete" handler
						if (_onDelete && _onDelete.length && _onDelete in window && undefined !== window[_onDelete]) {
							window[_onDelete].apply(this, [new_value]);
						}
					}
				}

				return false;
			});
		}, // end DingsAction

		Countdown: function(){
			if (! $('.__js_dings_countdown').length) return ;

			// hoist-block
			{
				var start = parseInt($('.__js_dings_countdown > .__js_dings_countdown_start').text()),
						end = parseInt($('.__js_dings_countdown > .__js_dings_countdown_end').text()),
						delay = 60000, // default 1 minute
						_onComplete = $('.__js_dings_countdown').attr('on-complete');

				// - completion 1 minute into 
				var runTime = (end - start);
				console.log(runTime);

				// - run countdown
				var counter = setInterval(function(){
					Core.helpers.updateCountdown($('.__js_dings_countdown'));
				}, delay);
			}
			// end hoist-block

			setTimeout(function(){
				clearInterval(counter);

				// execute custom "on-complete" handler
				if (_onComplete && _onComplete.length && _onComplete in window && undefined !== window[_onComplete]) {
					window[_onComplete].apply(this, []);
				}
			}, runTime * 1000);

		}, // end Countdown

		ChatableChannel: function(eventId, operation, data){
			var $counter = $('#digital-party-viewers .counter'),
					chatableMembers = window.__chatableMembers,
					current = Object.keys(chatableMembers).length;

			if ('open' === operation) {
				current = data && data.count ? data.count : 0;
				for (let id in data.members) {
					chatableMembers[id] = data.members[id];
				}
			}
			else if ('join' === operation) {
				current = current + 1;
				chatableMembers[data.id] = data;
			}
			else if ('leave' === operation) {
				current = current - 1;
				delete chatableMembers[data.id];
			}

			window.__chatableMembers = chatableMembers;
			$counter.text(current);

			// - do we need to track this operation?
			if ('open' === operation || 'leave' === operation) {
				/* no-await */
				API.methods.postPresence({
					operation,
					id: data.id ? data.id : data.myID,
					event: eventId
				});
			}
		} // end ChatableChannel

	};

	/**
	 * jQuery plugins - jQuery UI and others
	 *
	 * @internal
	 */
	Core.plugin = {
		init : function(){
			Core.plugin.mCustomScrollbar();
			Core.plugin.ui.accordion();
			Core.plugin.ui.slider();
			Core.plugin.ui.sortable();
			Core.plugin.ui.tabs();
			return false;
		},
		mCustomScrollbar:function(){
			if ($(".main-menu").length){
				$(".main-menu .content").mCustomScrollbar();
			}
			if ($(".notice-popup").length){
				$(".notice-popup .content").mCustomScrollbar();
			}
			return false;
		},
		ui: {
			accordion: function(){
				if ($( ".js__ui_accordion" ).length){
					$( ".js__ui_accordion" ).accordion({
						heightStyle: "content",
						collapsible: true
					});
				}
				return false;
			},
			slider: function(){
				$(".js__ui_slider").each(function(){
					var selector = $(this),
						slider = selector.find(".js__slider_range"),
						amount = selector.find(".js__slider_amount"),
						min = parseInt(selector.data("min"),10),
						max = parseInt(selector.data("max"),10),
						start = parseInt(selector.data("value-1"),10),
						end = parseInt(selector.data("value-2"),10),
						range = selector.data("range");

					if (end > 0){
						slider.slider({
							range: true,
							min: min,
							max: max,
							values: [ start, end ],
							slide: function( event, ui ) {
								amount.val( "$" + ui.values[0] + " - $" + ui.values[1] );
							}
						});
						amount.val( "$" + slider.slider( "values", 0 ) + " - $" + slider.slider( "values", 1 ) );
					}else{
						slider.slider({
							range: range,
							min: min,
							max: max,
							value: start,
							slide: function( event, ui ) {
								amount.val( "$" +  ui.value );
							}
						});
						amount.val("$" + slider.slider( "value" ) );
					}
				});
				return false;
			},
			sortable: function(){
				if ($(".js__sortable").length){
					$(".js__sortable").sortable({
						revert: true,
						start: function(e, ui){
							ui.placeholder.height(ui.item.height() - 20);
							ui.placeholder.css('visibility', 'visible');
						}
					});
				}
				return false;
			},
			tabs : function(){
				if ($(".js__ui_tab").length){
					$(".js__ui_tab").tabs();
				}
				return false;
			}
		}
	}
	
	/**
	 * PUBLIC API
	 * @public
	 */
	window.__dings_api = {
		updateComponents: function(){
			Core.module.dings();
		},
		refreshStore: function(){
			Core.module.store();
		},
		enableAsync: function(_parent){
			Core.helpers.initAsyncForms(_parent);
		},
		postFavorites: API.methods.postFavorites,
		postReception: API.methods.postReception,
		getPage: API.methods.getPage,
		animateCSS: Core.helpers.animateCSS,
		liveChatChannel: Core.helpers.addLiveChatMessage,
		liveChatOpen: function(eventId, data) { Core.components.ChatableChannel(eventId, 'open', data); },
		liveChatJoin: function(eventId, data) { Core.components.ChatableChannel(eventId, 'join', data); },
		liveChatLeave: function(eventId, data) { Core.components.ChatableChannel(eventId, 'leave', data); }
	};

})(jQuery);